import { render, staticRenderFns } from "./EInvoiceAwaitingApprovalList.vue?vue&type=template&id=8c35d116&"
import script from "./EInvoiceAwaitingApprovalList.vue?vue&type=script&lang=js&"
export * from "./EInvoiceAwaitingApprovalList.vue?vue&type=script&lang=js&"
import style0 from "./EInvoiceAwaitingApprovalList.vue?vue&type=style&index=0&id=8c35d116&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports